module.exports = __webpack_public_path__ + "static/media/ic_deactivate.98ddc8c4.svg";